import { StreetSearchResult } from '@models';

export function getStreetDescription(city: StreetSearchResult): string {
  return city?.Present;
}
